module.exports = __webpack_public_path__ + "media/a2.20cc6205.wav";